import { blueGrey, lightBlue } from "../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, palette }) => ({
  longSearchInput: {
    width: "95%"
  },
  shortSearchInput: {
    width: "70%"
  },
  header: {
    display: "flex",
    marginBottom: spacing(4),
    alignItems: "flex-end"
  },
  massActionContainer: {
    flexDirection: "row",
    alignItems: "center",
    visibility: "hidden"
  },
  visible: {
    visibility: "visible"
  },
  selectedRecordsBadge: {
    backgroundColor: lightBlue[600],
    color: palette.common.white,
    marginRight: spacing(2)
  },
  selectedRecordsTitle: {
    color: lightBlue[900],
    marginRight: spacing(4)
  },
  clearButton: {
    marginLeft: spacing(3)
  },
  countingRecords: {
    marginLeft: "auto",
    color: blueGrey[500]
  }
}))
